export default function Contact() {
  return (
    <div style={{ padding: "40px" }}>
      <h1 style={{ color: "#660909" }}>Contact Us</h1>

      <p>
        <strong>Address:</strong><br />
        DIET Dubacherla,<br />
        Nallajerla Mandal,<br />
        West Godavari District,<br />
        Andhra Pradesh.
      </p>

      <p>
        <strong>Phone:</strong> +91 99122 77177
      </p>

      <p>
        <strong>Email:</strong> dietwestgodavari@yahoo.com<br/>
        <strong>Email:</strong> dietwestgodavari.ictwing@gmail.com

      </p>
    </div>
  );
}